// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_eab1d3', '__Roboto_Fallback_eab1d3'","fontStyle":"normal"},"className":"__className_eab1d3"};